(() => {
  const clean = value => value.replace(/<\/?tc>|&lt;\/?tc&gt;/gi, '');
  const cleanTitles = root => {
    if (root.nodeType === Node.TEXT_NODE) {
      if (root.parentElement?.closest('script, style, template, textarea, [contenteditable]')) return;
      const value = clean(root.nodeValue);
      if (value !== root.nodeValue) root.nodeValue = value;
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    for (const element of [root, ...root.querySelectorAll('[alt], [aria-label], [title]')]) {
      for (const name of ['alt', 'aria-label', 'title']) {
        const value = element.getAttribute(name);
        if (value && clean(value) !== value) element.setAttribute(name, clean(value));
      }
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) cleanTitles(walker.currentNode);
  };
  // Legacy product widgets can insert translated names after the initial render.
  cleanTitles(document.body);
  const template = document.getElementById('RmFooterLanguageTemplate');
  const mount = () => {
    if (document.querySelector('footer.rm-footer-shell, footer .rm-footer-language')) return;
    const footer = Array.from(document.querySelectorAll('footer')).find(el => el.getClientRects().length);
    if (footer && template) footer.append(template.content.cloneNode(true));
  };
  mount();
  // Standalone product footers are mounted by React after the document loads.
  let scheduled = false;
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'childList') record.addedNodes.forEach(cleanTitles);
      else cleanTitles(record.target);
    }
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; mount(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['alt', 'aria-label', 'title'] });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('.rm-footer-language-form')) return;
    const current = new URL(window.location.href);
    if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') {
      current.searchParams.set('preview_theme_id', Shopify.theme.id);
    }
    let returnTo = form.querySelector('[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo);
    }
    const root = form.dataset.languageRoot || '/';
    const prefix = root.endsWith('/') ? root : root + '/';
    const pathname = current.pathname === prefix.slice(0, -1) ? '/' :
      (current.pathname.startsWith(prefix) ? '/' + current.pathname.slice(prefix.length) : current.pathname);
    returnTo.value = pathname + current.search + current.hash;
  }, true);
})();

